const INITIAL_STATE ={
markastate:[]
}

const  markareducer = (state=INITIAL_STATE,action) =>{
  switch (action.type) {
            case 'MARKA_DROPDOWN':
          return {...state, markastate:action.payload}
            default:
          return state;
  }
};

export default markareducer;